import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createIndexedDbStorage } from '@/utils/storage/indexeddb-storage';

const INITIAL_SHOW_COUNT = 5;

const useGlobalStore = create(
  persist(
    (set) => ({
      productInfo: {},
      defaultSourceIds: [],
      notifyProducts: [],
      isOldUser: false,
      deliveryPlaceType: null,
      savedSearchWords: [],
      paymentMethods: [],
      selectedEarningProgram: null,
      setIsOldUser: (isOldUser) => set(() => ({ isOldUser })),
      setProductInfo: (productInfo) => set(() => ({ productInfo })),
      setDeliveryPlaceType: (deliveryPlaceType) =>
        set(() => ({ deliveryPlaceType })),

      setDefaultSourceIds: (ids) => set(() => ({ defaultSourceIds: ids })),

      setNotifyProducts: (entity_id, userId) =>
        set((state) => {
          return {
            ...state,
            notifyProducts: state.notifyProducts.concat({ entity_id, userId }),
          };
        }),
      setSavedSearchWords: (searchedQuery) =>
        set((state) => {
          if (!searchedQuery || searchedQuery.length < 2) return state;

          // Remove duplicates, prepend new query, limit length
          const filtered = state.savedSearchWords.filter(
            (word) => word !== searchedQuery
          );
          const updatedWords = [searchedQuery, ...filtered].slice(
            0,
            INITIAL_SHOW_COUNT
          );

          return { savedSearchWords: updatedWords };
        }),

      setPaymentMethods: (paymentMethods) => set(() => ({ paymentMethods })),

      setSelectedEarningProgram: (selectedEarningProgram) =>
        set(() => ({ selectedEarningProgram })),

      removeSavedSearchWord: (word) =>
        set((state) => ({
          savedSearchWords: word
            ? state.savedSearchWords.filter((w) => w !== word)
            : [],
        })),
    }),

    {
      name: 'global',
      storage: createIndexedDbStorage('global'),
    }
  )
);

export default useGlobalStore;
